import { createMuiTheme } from '@material-ui/core/styles';
import indigo from '@material-ui/core/colors/indigo';
import teal from '@material-ui/core/colors/teal';
import red from '@material-ui/core/colors/red';

// A custom theme for this app
const theme = createMuiTheme({
    typography: {
        fontFamily: [
        'Lato',
        ].join(','),
        h1 : {
            fontFamily: "MuseoModerno",
        },
        h2 : {
            fontFamily: "MuseoModerno"
        },
        h3 : {
            fontFamily: "MuseoModerno"
        },
        h4 : {
            fontFamily: "MuseoModerno"
        },
        h5 : {
            fontFamily: "MuseoModerno"
        },
        button: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "1.6.rem", //"0.875rem",
            lineHeight: 1.75,
            letterSpacing: "0.04em", // "0.02857em",
            textTransform: ''
        }
    },
    palette: {
        primary: {
            main:indigo[800]
        },
        secondary: {
            main: teal[800]
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#FFF',
        },
    },
});

export default theme;
